<pr-form
  [formWithTabs]="true"
  (nextTab)="nextTab()"
  [tabChanged]="tabChanged"
  (onSubmit)="onSubmit()"
  [title]="title"
  [formGroup]="form"
  prLoader
  [loading]="loading"
  clazz="drawer-form"
>
  <button top-right-action class="btn-nostyle" type="button">
    <pr-icon
      name="sp-close"
      viewBoxHeight="23"
      viewBoxWidth="23"
      (click)="onCancel()"
    ></pr-icon>
  </button>

  @if (form.controls.type.value == null || iframe) {
    <div>
      <h3 class="drawer-title no-paddingtop">Type de connection souhaitée</h3>
      <ul>
        <li class="scaleUp" (click)="selectType('auto')">
          Synchronisation automatique
        </li>
        <li class="scaleUp" (click)="selectType('manual')">
          Connection manuelle
        </li>
      </ul>
    </div>
  }
  <div class="bi" style="height: 100%" [hidden]="!iframe"></div>

  <div [hidden]="form.controls.type.value == null">
    <pr-tabs
      clazz="drawer-tab-button"
      [defaultTextColor]="false"
      [changeTab]="changeTab"
      (lastTab)="onTabChange($event)"
    >
      <pr-tab label="Informations générales">
        <h3 class="drawer-title no-paddingtop">Informations du bien</h3>

        <div class="form-sct-container">
          <pr-input-autosuggest
            formControlName="product"
            label="Votre contrat"
            [options]="products"
            [derrors]="derrors"
            [hidden]="isAutomaticFlux"
            [optionLabel]="'name'"
          >
          </pr-input-autosuggest>

          <pr-input-date
            formControlName="startDate"
            label="Date d'ouverture"
            [derrors]="derrors"
          ></pr-input-date>

          <pr-input label="Montant actuel" suffix="€" [derrors]="derrors">
            <input formControlName="lastValue" type="text" />
          </pr-input>

          <pr-input label="Versement initial" suffix="€" [derrors]="derrors">
            <input formControlName="purchasePrice" type="text" />
          </pr-input>

          <pr-input label="Versement mensuel" suffix="€" [derrors]="derrors">
            <input formControlName="monthlyPayment" type="text" />
          </pr-input>

          <pr-input-radio
            formControlName="nanti"
            label="Nantissement"
            toggleBgEmpty="true"
          >
          </pr-input-radio>
        </div>

        <h3 class="drawer-title">Répartition de vos supports</h3>

        <div class="form-sct-container">
          <div class="pr-form-list-add">
            <pr-button
              [hidden]="!hideTable"
              clazz="btn-list-add neutral"
              rightIcon="sp-plus"
              label="Ajouter un nouveau support"
              (onClick)="openSupportsForm()"
            ></pr-button>
          </div>
          <pr-table-form
            [hidden]="hideTable"
            #tableForm
            [formGroup]="allocation"
            [addButtonLabel]="'Gérer les supports'"
            swiperMinWidth="768"
            (onSelectClick)="openSupportsForm()"
            [columnsDefinition]="columnsDefinition"
            [formatTable]="formatTableDataFunction()"
            [createModelDefinition]="createModel"
            variant="ASSET_SUPPORT"
            (optionSelected)="newOptionLogic()"
            (noData)="onSupportsChange($event)"
          >
          </pr-table-form>

          <pr-color-panel
            [hidden]="
              !allocation || !allocation.value || allocation.value.length == 0
            "
            [display]="allocationPanel.display"
          >
            <pr-panel-body clazz="pam">
              <pr-label
                [name]="allocationPanel.icon"
                [width]="18"
                [height]="18"
                labelDefaultClass="fs-14 fw-500"
                >{{ allocationPanel.text }}</pr-label
              >
            </pr-panel-body>
          </pr-color-panel>
        </div>
      </pr-tab>
      <pr-tab label="Détention">
        <pr-input label="Acquis au travers de" [derrors]="derrors">
          <mat-select formControlName="subscriptionSource">
            @for (item of sources; track item) {
              <mat-option [value]="item.id">
                {{ item.label }}
              </mat-option>
            }
          </mat-select>
        </pr-input>

        <pr-input-owner-share
          formControlName="owners"
          [derrors]="derrors"
        ></pr-input-owner-share>
      </pr-tab>
    </pr-tabs>
  </div>

  <pr-subform
    #supportsForm
    [formGroup]="allocation"
    [context]="this"
    submitbtnLabel="Sauvegarder"
    (onOpen)="defaultAllocationFormValue = form.value"
    (onCancel)="cancelManageAllocationform()"
    (onValidate)="validManageAllocationform()"
  >
    <ng-container formContent>
      <h4 class="drawer-title">Saisissez les supports que vous possédez</h4>
      <form [formGroup]="criteriaForm">
        <pr-search-input
          formControlName="autocomplete"
          variant="ASSET_SUPPORT"
          placeholder="Recherchez un support financier"
          class="mbm"
        >
          <mat-select
            filterSelection
            formControlName="supportTypes"
            class="pr-button neutral filter-selection"
            placeholder="Tous"
          >
            <mat-option [value]="undefined">Tous</mat-option>
            @for (type of supportTypes; track type) {
              <mat-option [value]="type.id">
                {{ type.value }}
              </mat-option>
            }
          </mat-select>
        </pr-search-input>
      </form>

      <pr-form-select-list #formSelectList clazz="support-list">
        @for (support of supports; track support) {
          <pr-form-select-list-option
            variant="ASSET_SUPPORT"
            [label]="support.name"
            [labelIcon]="support.favorite ? 'sp-cup' : undefined"
            [subLabel]="support.isin"
            [infoLabel]="getSupportTypeValue(support)"
            [infoClass]="getInfoLabelColor(support)"
            [selected]="
              _.map(form.get('allocation').value, 'isin').includes(support.isin)
            "
            [criterias]="[
              {
                label: 'Performance',
                value: '~',
                options: { color: 'success' },
              },
            ]"
            [withMoreInfoAnchor]="support.omniProductId"
            (onSelect)="onSupportSelect(support)"
            (onDeselect)="onSupportDeselect(support)"
            (onMoreInfoClick)="onMoreInfoClick(support)"
          >
          </pr-form-select-list-option>
        }
      </pr-form-select-list>
      <mat-paginator
        [length]="supportsLength"
        [pageSize]="supportsPageSize"
        (page)="changeSupportsPage($event)"
      >
      </mat-paginator>
    </ng-container>
  </pr-subform>
</pr-form>
